import { ArrowUp } from "lucide-react";

const LOGO = "https://lirp.cdn-website.com/b68b7c9b/dms3rep/multi/opt/1-edeac864-1920w.png";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-white border-t border-cgborder pt-20 pb-10"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid md:grid-cols-12 gap-12 mb-16">
          <div className="md:col-span-5">
            <img src={LOGO} alt="Cargides Group" className="h-10 w-auto mb-6" data-testid="footer-logo" />
            <p className="text-cgmuted max-w-sm leading-relaxed text-[15px]">
              Met Cargides richten we ons vooral op bedrijfswagens. Vertrekkende
              vanuit passie wordt uw wagen gekuist zoals het hoort.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-[0.2em] text-cgprimary font-semibold mb-5">
              Gegevens
            </div>
            <ul className="space-y-2 text-cgdark text-[14px]" data-testid="footer-company-info">
              <li className="text-cgmuted">BE 0784.311.910</li>
              <li>Sportstraat 13</li>
              <li>8560 Wevelgem</li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="text-xs uppercase tracking-[0.2em] text-cgprimary font-semibold mb-5">
              Contact
            </div>
            <ul className="space-y-2 text-cgdark text-[14px]">
              <li>
                <a href="tel:+32496614638" className="link-underline" data-testid="footer-phone">
                  +32 496 61 46 38
                </a>
              </li>
              <li>
                <a href="mailto:info@cargidesgroup.be" className="link-underline break-all" data-testid="footer-email">
                  info@cargidesgroup.be
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="text-xs uppercase tracking-[0.2em] text-cgprimary font-semibold mb-5">
              Legaal
            </div>
            <ul className="space-y-2 text-cgdark text-[14px]">
              <li>
                <a
                  href="https://irp.cdn-website.com/b68b7c9b/files/uploaded/Algemene%20voorwaarden.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="link-underline"
                  data-testid="footer-terms"
                >
                  Algemene voorwaarden
                </a>
              </li>
              <li>
                <a
                  href="https://www.cargidesgroup.be/privacybeleid"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="link-underline"
                  data-testid="footer-privacy"
                >
                  Privacybeleid
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-cgborder pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-xs text-cgmuted">
            © {new Date().getFullYear()} Cargides Group. Alle rechten voorbehouden.
          </p>
          <a
            href="#home"
            className="inline-flex items-center gap-2 text-xs font-semibold tracking-[0.15em] uppercase text-cgdark hover:text-cgprimary transition-colors"
            data-testid="footer-back-to-top"
          >
            Terug naar boven <ArrowUp size={14} />
          </a>
        </div>
      </div>
    </footer>
  );
}
